<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><a href="/item-table">{{ $t('product.catalogue') }}</a></li>
					<li><span>{{ $t('item.create') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="row" v-if="!$store.getters.getLoadingStatus">
			<div class="col-sm-12">
				<div class="sidebar">
					<button id="sidebar_save" onclick="editableTradeItem.itemCreate();" type="submit">
						<span uk-icon="save"></span>
						<span class="title">{{ $t('save') }}</span>
					</button>
					<button id="sidebar_switch-default-value" type="submit">
						<span uk-icon="unlock"></span>
						<span class="title">{{ $t('switch.default.value') }}</span>
					</button>
					<button id="sidebar_drop-item-state" onclick="window.ClientSessionManager.dropItemState(false);"
							type="submit">
						<span uk-icon="close"></span>
						<span class="title">{{ $t('drop.item.state') }}</span>
					</button>
					<button id="sidebar_groups" @click="setTabsVisible()" type="submit">
						<span uk-icon="list"></span>
						<span class="title">{{ $t('enable.disable.groups') }}</span>
					</button>
					<button id="sidebar_help" type="submit">
						<span uk-icon="question"></span>
						<span class="title">{{ $t('help') }}</span>
					</button>
					<button id="sidebar_copy-attribute-name"
							onclick="editableTradeItem.setEnableCopyAttributeName()"
							:class="enableCopyAttributeName ? 'sidebar_marked-button' : ''">
						<span uk-icon="copy"></span>
						<span class="title">{{ $t('copy.attribute.name') }}</span>
					</button>
					<button id="sidebar_recalculate-attributes" @click="attributesRecalculate">
						<span class="fa fa-calculator"></span>
						<span class="title">{{ $t('recalculate.attributes') }}</span>
					</button>
				</div>
			</div>
		</div>

		<div class="spinner-wrapper">
			<div class="spinner-border" role="status" v-if="$store.getters.getLoadingStatus">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<div class="row" v-if="!$store.getters.getLoadingStatus">
			<div class="col-sm-12">
				<div class="form form-with-sidebar">
					<div id="dictionary-add-form">
						<div id="dictionary-value-area"><textarea id="new-dict-value" rows="2"></textarea></div>
						<button id="dictionary-save-button" class="button button-neutral">{{ $t('save') }}</button>
					</div>
					<div class="row">
						<div class="form-body">
							<tab-header class="row" :tabs-title="attributesGroups" :localization="localization" :activeTab="defaultTab"
										@current-tab="currentTab"/>
							<div class="row">
								<div class="col-sm-12">
									<div class="tab-content" :key="tabContentKey">
										<div class="tab-pane" :class="defaultTab === tab.title ? 'active': ''" v-for="tab in attributesGroups" :id="tab.title"
											 :key="tab.title">
											<div class="row" v-if="defaultTab === tab.title || openTabs.includes(tab.title)">
												<div class="row attributes-group-area">
													<div class="col-sm-12"><span>{{ tab.title }}</span></div>
												</div>
												<div v-for="itemCol in splitArr(tab.attributes)"
													 :class="'col-sm-' + 12 / countColumns">
													<AttributeBuilder
														v-for="item in itemCol"
														:key="item.title"
														:attribute-name="item.title"
														:localized-title="localization"
														:is-value-key="isValueKey"
														:is-required="itemsValidation"
														:is-primary="itemPk"
														:prev-values-dictionary="prevValuesDictionary"
														:language="language"
														:localization="localization"
														:classificators="classificators"
														:measurement-units="measurementUnits"
														:item-config=itemsConfig
														:item=item
														:item-data="itemData"
														:enable-copy-attribute-name=enableCopyAttributeName
													/>
												</div>
											</div>
										</div>
										<div class="tab-pane" id="calculateTest">
											<div v-access:can="[Const.PERMISSION_ROLE_ADMIN]" class="row">
												<div ref="commandline" id="commandline">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="item-modifications" class="row"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { chunkTabAttribute, countColumns, mapAttrTabs } from '@/services/shared'
import { CONFIGURATIONS_ITEM_EDIT } from 'actions/configurations'
import TabHeader from 'components/item-edit/TabHeader'
import AttributeEditorComponent from 'components/item-edit/AttributeEditorComponent'
import AttributeWrapperForEditableComponent from 'components/item-edit/AttributeWrapperForEditableComponent'
import AttributeBuilder from 'components/item-edit/AttributeBuilder'
import { Fragment } from 'vue-fragment'
import { ItemProcessor } from '@/core/item_assistance/ItemProcessor'
import { initSidebar } from '@/core/support_gui_components/sidebar/sidebar'
import { initTabAction, initTabAttributeContent } from '@/core/item_assistance/initItemData'
import { initDatepicker } from '@/core/input_controls/datepicker/datepicker'
import { initThreeStateCheckbox } from '@/core/input_controls/checkbox/checkbox'
import {
	enableAllHotkeysForAttributeEditors,
	enableAllHotkeysForAttributeGroups, enableHotkeyForDefaultValues,
	enableHotkeyForSave
} from '@/core/hotkey/HotkeyFunctions'
import { enablePrevValuesDictionarySupport } from '@/core/support_gui_components/prevValuesDictionary/prevValuesDictionary'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { CopyToClipboard, disableLockableEditorsWithDefaultValues, removeTabindex } from '@/core/shared'
import {
	attachRegistrationOfSelectedAttribute,
	isEnabledDefaults,
	isGroupMode,
	setTabsVisible
} from '@/core/core_components/form/form'
import { bindResetButton } from '@/core/input_controls/button/button'
import { attributesRecalculate } from '@/mixins/attributesRecalculate'
import CommandLineEditor from 'utils/mathtester'
import { flatDeepAttributes } from 'utils/format'

export default {
	name: 'ItemCreate',
	metaInfo () {
		return {
			title: this.$t('item.create')
		}
	},
	props: [
		'sourceItemId'
	],
	components: {
		TabHeader,
		AttributeEditorComponent,
		AttributeWrapperForEditableComponent,
		AttributeBuilder,
		Fragment
	},
	mixins: [
		attributesRecalculate
	],
	data () {
		return {
			attributesGroups: [],
			itemPk: [],
			localization: {},
			language: [],
			itemValidationRules: [],
			prevValuesDictionary: [],
			classificators: [],
			measurementUnits: [],
			itemStructure: [],
			countColumns: countColumns(),
			itemsConfig: [],
			itemsValidation: [],
			enableCopyAttributeName: false,
			itemData: {},
			defaultTab: '',
			openTabs: [],
      tabContentKey: 0
		}
	},
	methods: {
		getConfiguration: function () {
			this.$store.commit('IS_CREATE_PAGE', true)
			let url = this.sourceItemId ? `/items/${this.sourceItemId}/load` : null

			this.$store.dispatch(CONFIGURATIONS_ITEM_EDIT, url)
				.then(() => {
					this.attributesGroups = this.$store.getters.getAttributesGroups
					this.itemPk = this.$store.getters.getItemPk
					this.language = this.$store.getters.getLanguage
					this.itemValidationRules = this.$store.getters.getItemValidationRules
					this.prevValuesDictionary = this.$store.getters.getPrevValuesDictionary
					this.classificators = this.$store.getters.getClassificators
					this.measurementUnits = this.$store.getters.getMeasurementUnits
					this.itemStructure = this.$store.getters.getItemStructure
					this.itemsConfig = this.$store.getters.getItemStructure
					this.itemData = this.$store.getters.getItemData
				})
				.then(() => {
					this.setDefaultTab()
					this.initEditableTradeItem()
				})
				.catch(errors => {
					console.error(errors)
					this.rollbar.error('CONFIGURATIONS_ITEM_EDIT', errors)
				})
		},
		initEditableTradeItem: function () {
			window.CopyToClipboard = CopyToClipboard

			window.editableTradeItem = new ItemProcessor()
			editableTradeItem.setSourceItemData(this.itemData)
			editableTradeItem.setItemConfig(this.itemStructure)
			editableTradeItem.setItemId(false)
			editableTradeItem.setAttributesGroups(this.attributesGroups)
			editableTradeItem.setItemPk(this.itemPk)
			editableTradeItem.setLocalization(this.localization)
			editableTradeItem.setLanguage(this.language)
			editableTradeItem.setItemValidationRules(this.itemValidationRules)
			editableTradeItem.setPrevValuesDictionary(this.prevValuesDictionary)
			editableTradeItem.setClassificators(this.classificators)
			editableTradeItem.setMeasurementUnits(this.measurementUnits)

			$(document).focus()
			initSidebar(['save', 'switch-default-value', 'groups', 'help', 'drop-item-state', 'recalculate-attributes'])
			initTabAction()
			initTabAttributeContent()
			initDatepicker()
			initThreeStateCheckbox('.form')

			window.ClientSessionManager.setItemConfig(editableTradeItem.itemConfig)

			//hotkeys
			enableAllHotkeysForAttributeGroups()
			enableAllHotkeysForAttributeEditors()
			enableHotkeyForSave()
			enableHotkeyForDefaultValues()

			//components
			enablePrevValuesDictionarySupport()
			enableMulticheckboxSupport()

			disableLockableEditorsWithDefaultValues()
			attachRegistrationOfSelectedAttribute(editableTradeItem)
			editableTradeItem.initItemAttributeControls(!(this.sourceItemId), null)

			bindResetButton()
			removeTabindex()

			editableTradeItem.unsavedDataManager.updateUnsavedDataSign()

			let container = this.$refs.commandline
			if (container) {
				this.$nextTick(function () {
					new CommandLineEditor({
						container: container,
						math: this.$math,
						context: this
					})
				})
			}

		},
		isValueKey: function (itemKey, array) {
			for (let i = 0; i < array.length; i++) {
				if (itemKey === array[i]) {
					return true
				}
			}
			return false
		},
		setEnableCopyAttributeName: function () {
			this.enableCopyAttributeName = !this.enableCopyAttributeName
		},
		splitArr: function (arr) {
			let mapAttr = []
			mapAttrTabs(arr, mapAttr, this.itemsConfig, this.language)
			return chunkTabAttribute(mapAttr, arr)
		},
		setTabsVisible: function () {
			this.attributesGroups.forEach(a => {
				if (!this.openTabs.includes(a.title)) {
					this.openTabs.push(a.title)
				}
			})

			this.$nextTick(() => {
				const isGroup = !isGroupMode()
				setTabsVisible(isGroup)
				this.enableGroups = isGroup
			})
		},
		currentTab: function (tab) {
			if (!this.openTabs.includes(tab)) {
				this.openTabs.push(tab)
			}
			this.defaultTab = tab
		},
		setDefaultTab: function () {
			const attributesGroups = this.attributesGroups
			const activeAttr = this.activeAttribute
			let activeTab = attributesGroups[0].title

			if (!activeAttr) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
				return
			}

			attributesGroups.forEach(a => {
				let attr = flatDeepAttributes(a.attributes)
				if (attr.includes(activeAttr)) {
					activeTab = a.title
				}
			})

			if (activeTab) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
			}
		}
	},
	mounted () {
		this.getConfiguration()
	},
	created () {
		document.addEventListener('enableCopyAttributeName', this.setEnableCopyAttributeName)
	},
	beforeRouteLeave (to, from, next) {
		window.ClientSessionManager.saveItemState(editableTradeItem, isGroupMode(), isEnabledDefaults())
		next()
	}
}
</script>

<style scoped>
.spinner-wrapper {
	display: flex;
	justify-content: center;
}

.spinner-border {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: text-bottom;
	border: .25em solid #ececec;
	border-right-color: transparent;
	border-radius: 50%;
	-webkit-animation: spin .75s linear infinite;
	animation: spin .75s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
